import authModule from "../../../../../utilities/AuthModule";
import { ComponentTypes } from "../../../config/config";
import { IFolderPanelInfo } from "../../../interfaces/IFolderPanelInfo";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { BaseFolderPanelHelper } from "./BaseFolderPanelHelper";
import { IFolderPanelHelper } from "../../../interfaces/IFolderPanelHelper";


export class SharepointSubsitePanelHelper extends BaseFolderPanelHelper implements IFolderPanelHelper {
    constructor(
        folderPanelInfo: IFolderPanelInfo,
        currentDirectory: IPageSettings) {
        super(folderPanelInfo, currentDirectory);
    }

    async getFolderFinalLocation(): Promise<IPageSettings> {
        return {
            type: ComponentTypes.SharePointDocuments,
            siteId: this.folderPanelInfo.folder.id,
            siteDisplayName: this.folderPanelInfo.folder.name,
            webUrl: this.folderPanelInfo.webUrl,
            directory: "",
            DocumentLibrary: "",
            displayName: this.folderPanelInfo.folder.name,
            tessProjectId: this.folderPanelInfo.tessProjectId
        };
    }

    async save() {

    }
}
